import React from 'react'
import './resources/css/layout.css';
import './resources/css/layoutnueva.css';

import {
    estadoChangePagina,
    PAGE_PRINCIPAL,
    PAGE_CLINICAS, PAGE_DOCTORES, PAGE_PACIENTES,
    PAGE_CITAS, PAGE_HISTORIA,
    PAGE_PAGOS, PAGE_TRATAMIENTOS, PAGE_TRATAMIENTOTIPOS, PAGE_CONSENTIMIENTOTIPOS,
    PAGE_UTILIDADES, PAGE_SALAESPERA,
} from './redux/estado/actions'

import { connect } from 'react-redux';



import MenuLateral from "./MenuLateral"
import FormularioUsuario from "./sistema/FormularioUsuario";
import FormularioRol from "./sistema/FormularioRol";
import Clinicas from "./general/Clinicas";
import Doctores from "./general/Doctores";
import Pacientes from "./general/Pacientes";
import Historia from "./general/Historia";
import Citas from "./citas/Citas";
import Pagos from "./general/Pagos";
import Tratamientos from "./general/Tratamientos";
import TratamientoTipos from "./general/TratamientoTipos";
import {getDispositivo} from "./utils/WindowUtils";
import MenuLateralTablet from "./MenuLateralTablet";
import Principal from "./general/Principal";
import Consentimientotipos from "./general/ConsentimientoTipos";
import Utilidades from "./general/Utilidades";
import Salaesperas from "./general/Salaesperas";

class Content extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.dispositivo= getDispositivo();
    }

    seleccionPagina= (pagina) => {
        this.props.dispatch(estadoChangePagina(pagina));
    }

ShowPagina= () => {
        const {estado} = this.props;
        if (estado) {
            switch (estado.pagina) {
                //case PAGE_PRINCIPAL: return (<Principal />);
                case PAGE_CLINICAS: return (<Clinicas />);
                case PAGE_DOCTORES: return (<Doctores />);
                case PAGE_PACIENTES: return (<Pacientes />);
                case PAGE_HISTORIA: return (<Historia />);
                case PAGE_TRATAMIENTOS: return (<Tratamientos />);
                case PAGE_TRATAMIENTOTIPOS: return (<TratamientoTipos />);
                case PAGE_CITAS: return (<Citas />);
                case PAGE_PAGOS: return (<Pagos />);
                case PAGE_CONSENTIMIENTOTIPOS: return (<Consentimientotipos />);
                case PAGE_UTILIDADES: return (<Utilidades/>);
                case PAGE_SALAESPERA: return (<Salaesperas />);
                default: return (<></>);
            }
        }
    }

    render() {
        console.log("this.dispositivo: ", this.dispositivo);
        return (
            <div className="row">
                {/*<Principal />*/}

                <div className="columnMenu">
                    { this.dispositivo == 'desktop' && <MenuLateral/> }
                    { this.dispositivo == 'tablet' && <MenuLateralTablet/> }
                </div>
                <div className="columnContent" id="columnContent">
                    {this.ShowPagina()}
                </div>

            </div>
        );
    }

    renderAlt() {
        return (
            <main>
                <aside className="sidebar">
                    { this.dispositivo == 'desktop' && <MenuLateral/> }
                    { this.dispositivo == 'tablet' && <MenuLateralTablet/> }
                </aside>
                <section className="content">
                    {this.ShowPagina()}
                </section>
            </main>
        );
    }
}



const mapStateToProps = function(state) {
    return {
        estado: state.estado,
        auth: state.auth,
    }
}

export default connect(mapStateToProps)(Content);

